class FluxKB {
  constructor(document) {
    document = document || {}
    this.enabled = document.enabled || false
    this.title = document.title || 'Olá! Em que podemos te ajudar?'
  }
}

module.exports = FluxKB
